
function DataSearch(APIData, searchValue,columns){
    if(columns != undefined){
        const keys = columns.map(({value }) =>value);
        const filteredData = APIData?.filter((item) => {
            return keys?.some(key => typeof item[key] != 'string' ? item[key]?.toString().toLowerCase().includes(searchValue.toLowerCase()) 
            : item[key]?.toLowerCase().includes(searchValue.toLowerCase()))
        })
        return filteredData
    }
    else{
        const filteredData = APIData?.filter((item) => {
            return Object.values(item).join(',').toLowerCase().includes(searchValue.toLowerCase())
        })
        return filteredData
    }      
}
export default DataSearch;

